import styled from 'styled-components';
import { CalciteButton } from 'components/Calcite';

export const NavigationButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${props => props.theme.baseline} 0;
`;

export const StyledNextBtn = styled(CalciteButton)`
  margin-left: auto;
`;
